import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const rotuloStatus = { ativo: 'Ativo', inativo: 'Inativo', suspenso: 'Suspenso' };

function exportarClientesPDF(lista, tituloFiltro) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Clientes</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Clientes ${tituloFiltro ? `— ${tituloFiltro}` : ''}</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — ${lista.length} cliente${lista.length !== 1 ? 's' : ''} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Nome</th><th>Documento</th><th>Cidade</th><th>Celular</th><th>Email</th><th>Plano</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${lista.map(c => `
            <tr>
              <td>${c.nome_fantasia || '—'}</td>
              <td>${c.documento || '—'}</td>
              <td>${[c.cidade, c.estado].filter(Boolean).join('/') || '—'}</td>
              <td>${c.celular || '—'}</td>
              <td>${c.email || '—'}</td>
              <td>${c.plano === 'sem_bloqueio' ? 'Sem bloqueio' : 'Com bloqueio'}</td>
              <td>${rotuloStatus[c.status === 'suspenso' ? 'suspenso' : (c.status === 'ativo' ? 'ativo' : 'inativo')]}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarClientesCSV(lista) {
  const linhas = [
    'Nome,Documento,Cidade,Estado,Celular,Email,Plano,Status',
    ...lista.map(c => {
      const status = c.status === 'suspenso' ? 'Suspenso' : (c.status === 'ativo' ? 'Ativo' : 'Inativo');
      const campos = [c.nome_fantasia, c.documento, c.cidade, c.estado, c.celular, c.email, c.plano === 'sem_bloqueio' ? 'Sem bloqueio' : 'Com bloqueio', status];
      return campos.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(',');
    })
  ];
  const blob = new Blob(['\ufeff' + linhas.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `clientes_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
}

function Clientes() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [form, setForm] = useState({
    nome_fantasia: '', razao_social: '', documento: '',
    email: '', celular: '', celular2: '', celular3: '', cep: '', endereco: '',
    numero: '', bairro: '', cidade: '', estado: '', plano: 'com_bloqueio'
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarClientes(); }, []);

  const carregarClientes = async () => {
    try {
      const res = await axios.get(`${API}/clientes`, { headers });
      setClientes(res.data);
    } catch (err) { console.error(err); }
  };

  const buscarCep = async (cep) => {
    const c = cep.replace(/\D/g, '');
    if (c.length === 8) {
      const res = await fetch(`https://viacep.com.br/ws/${c}/json/`);
      const data = await res.json();
      if (!data.erro) setForm(f => ({ ...f, endereco: data.logradouro, bairro: data.bairro, cidade: data.localidade, estado: data.uf }));
    }
  };

  const salvar = async () => {
    if (!form.nome_fantasia) return alert('Nome é obrigatório!');
    setSalvando(true);
    try {
      if (clienteSelecionado) {
        await axios.put(`${API}/clientes/${clienteSelecionado.id}`, form, { headers });
      } else {
        await axios.post(`${API}/clientes`, form, { headers });
      }
      fecharModal();
      carregarClientes();
    } catch (err) { alert('Erro ao salvar cliente'); }
    setSalvando(false);
  };

  const editar = (cliente) => {
    setClienteSelecionado(cliente);
    setForm({
      nome_fantasia: cliente.nome_fantasia || '',
      razao_social: cliente.razao_social || '',
      documento: cliente.documento || '',
      email: cliente.email || '',
      celular: cliente.celular || '',
      celular2: cliente.celular2 || '',
      celular3: cliente.celular3 || '',
      cep: cliente.cep || '',
      endereco: cliente.endereco || '',
      numero: cliente.numero || '',
      bairro: cliente.bairro || '',
      cidade: cliente.cidade || '',
      estado: cliente.estado || '',
      plano: cliente.plano || 'com_bloqueio'
    });
    setModalAberto(true);
  };

  const efetivoStatus = (c) => c.status === 'suspenso' ? 'suspenso' : (c.status === 'ativo' ? 'ativo' : 'inativo');

  const mudarStatus = async (cliente, novoStatus) => {
    try {
      await axios.put(`${API}/clientes/${cliente.id}`, { ...cliente, status: novoStatus }, { headers });
      carregarClientes();
    } catch (err) { alert('Erro ao atualizar status'); }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setClienteSelecionado(null);
    setForm({ nome_fantasia: '', razao_social: '', documento: '', email: '', celular: '', celular2: '', celular3: '', cep: '', endereco: '', numero: '', bairro: '', cidade: '', estado: '', plano: 'com_bloqueio' });
  };

  const clientesFiltrados = clientes.filter(c => {
    const buscaOk = c.nome_fantasia?.toLowerCase().includes(busca.toLowerCase()) ||
      c.documento?.includes(busca) ||
      c.cidade?.toLowerCase().includes(busca.toLowerCase());
    const statusOk = !filtroStatus || efetivoStatus(c) === filtroStatus;
    return buscaOk && statusOk;
  });

  const totalAtivos = clientes.filter(c => efetivoStatus(c) === 'ativo').length;
  const totalInativos = clientes.filter(c => efetivoStatus(c) === 'inativo').length;
  const totalSuspensos = clientes.filter(c => efetivoStatus(c) === 'suspenso').length;

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', alignItems: 'center', gap: '16px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>👥 Clientes</span>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>({clientes.length} cadastrados)</span>
      </div>

      <div style={{ paddingTop: '80px', padding: '80px 24px 24px' }}>

        {/* Contadores — clique pra filtrar */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: 'Total de clientes', valor: clientes.length, cor: '#1D9E75', chave: null },
            { label: '🟢 Ativos', valor: totalAtivos, cor: '#22C55E', chave: 'ativo' },
            { label: '🟡 Suspensos', valor: totalSuspensos, cor: '#F59E0B', chave: 'suspenso' },
            { label: '🔴 Inativos', valor: totalInativos, cor: '#EF4444', chave: 'inativo' },
          ].map(card => (
            <div key={card.label} onClick={() => setFiltroStatus(filtroStatus === card.chave ? null : card.chave)}
              style={{
                background: 'white', borderRadius: '12px', padding: '20px', cursor: 'pointer',
                boxShadow: filtroStatus === card.chave ? `0 0 0 2px ${card.cor}, 0 2px 8px rgba(0,0,0,0.06)` : '0 2px 8px rgba(0,0,0,0.06)',
                borderLeft: `4px solid ${card.cor}`, transition: 'box-shadow 0.15s'
              }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: card.cor }}>{card.valor}</div>
              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{card.label}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '1 1 400px' }}>
            <input placeholder="🔍 Buscar por nome, documento ou cidade..." value={busca} onChange={e => setBusca(e.target.value)} style={{ ...inputStyle, width: '400px' }} />
            {filtroStatus && (
              <span style={{ fontSize: '12px', color: '#666' }}>
                Filtrando: <strong>{rotuloStatus[filtroStatus]}</strong>{' '}
                <button onClick={() => setFiltroStatus(null)} style={{ background: 'none', border: 'none', color: '#1D9E75', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline' }}>limpar</button>
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => exportarClientesPDF(clientesFiltrados, filtroStatus ? rotuloStatus[filtroStatus] : null)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📄 Exportar PDF</button>
            <button onClick={() => exportarClientesCSV(clientesFiltrados)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📥 Exportar Excel</button>
            <button onClick={() => setModalAberto(true)} style={{ background: '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>+ Novo Cliente</button>
          </div>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f8f8' }}>
                {['Nome', 'Documento', 'Cidade', 'Celular', 'Plano', 'Status', 'Ações'].map(h => (
                  <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {clientesFiltrados.length === 0 ? (
                <tr><td colSpan="7" style={{ padding: '48px', textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '48px', marginBottom: '12px' }}>👥</div>
                  <div>Nenhum cliente encontrado</div>
                </td></tr>
              ) : clientesFiltrados.map((c, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                  <td style={{ padding: '14px 16px', fontSize: '14px', fontWeight: '500' }}>{c.nome_fantasia}</td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>{c.documento}</td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>{c.cidade}/{c.estado}</td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>
                    {c.celular || '—'}
                    {(c.celular2 || c.celular3) && (
                      <span title={[c.celular2, c.celular3].filter(Boolean).join(' / ')} style={{ marginLeft: '6px', background: '#E6F1FB', color: '#185FA5', borderRadius: '10px', padding: '1px 7px', fontSize: '11px', fontWeight: '600', cursor: 'default' }}>
                        +{[c.celular2, c.celular3].filter(Boolean).length}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: '14px 16px', fontSize: '14px', color: '#666' }}>{c.email}</td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{ background: c.plano === 'sem_bloqueio' ? '#FAEEDA' : '#E1F5EE', color: c.plano === 'sem_bloqueio' ? '#633806' : '#0F6E56', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                      {c.plano === 'sem_bloqueio' ? '🔓 Sem bloqueio' : '🔒 Com bloqueio'}
                    </span>
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    {(() => { const st = efetivoStatus(c); const cores = { ativo: ['#E1F5EE', '#0F6E56'], suspenso: ['#FFF3CD', '#856404'], inativo: ['#FCEBEB', '#A32D2D'] }; return (
                      <span style={{ background: cores[st][0], color: cores[st][1], padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        {rotuloStatus[st]}
                      </span>
                    ); })()}
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <button onClick={() => editar(c)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>✏️ Editar</button>
                      <select value={efetivoStatus(c)} onChange={e => mudarStatus(c, e.target.value)}
                        style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '6px 8px', fontSize: '12px', background: 'white', cursor: 'pointer' }}>
                        <option value="ativo">🟢 Ativo</option>
                        <option value="suspenso">🟡 Suspenso</option>
                        <option value="inativo">🔴 Inativo</option>
                      </select>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '620px', maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>{clienteSelecionado ? '✏️ Editar Cliente' : '➕ Novo Cliente'}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Nome Fantasia *</label>
                <input style={inputStyle} value={form.nome_fantasia} onChange={e => setForm({ ...form, nome_fantasia: e.target.value })} placeholder="Nome do cliente" />
              </div>
              <div>
                <label style={labelStyle}>Razão Social</label>
                <input style={inputStyle} value={form.razao_social} onChange={e => setForm({ ...form, razao_social: e.target.value })} placeholder="Razão social" />
              </div>
              <div>
                <label style={labelStyle}>CPF / CNPJ</label>
                <input style={inputStyle} value={form.documento} onChange={e => setForm({ ...form, documento: e.target.value })} placeholder="000.000.000-00" />
              </div>
              <div>
                <label style={labelStyle}>Email</label>
                <input style={inputStyle} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="email@exemplo.com" />
              </div>
              <div>
                <label style={labelStyle}>Celular</label>
                <input style={inputStyle} value={form.celular} onChange={e => setForm({ ...form, celular: e.target.value })} placeholder="(43) 99999-9999" />
              </div>
              <div>
                <label style={labelStyle}>Celular 2 (opcional)</label>
                <input style={inputStyle} value={form.celular2} onChange={e => setForm({ ...form, celular2: e.target.value })} placeholder="(43) 99999-9999" />
              </div>
              <div>
                <label style={labelStyle}>Celular 3 (opcional)</label>
                <input style={inputStyle} value={form.celular3} onChange={e => setForm({ ...form, celular3: e.target.value })} placeholder="(43) 99999-9999" />
              </div>
              <div>
                <label style={labelStyle}>CEP</label>
                <input style={inputStyle} value={form.cep} onChange={e => { setForm({ ...form, cep: e.target.value }); buscarCep(e.target.value); }} placeholder="86010-000" />
              </div>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Endereço</label>
                <input style={inputStyle} value={form.endereco} onChange={e => setForm({ ...form, endereco: e.target.value })} placeholder="Preenchido automaticamente pelo CEP" />
              </div>
              <div>
                <label style={labelStyle}>Número</label>
                <input style={inputStyle} value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} placeholder="123" />
              </div>
              <div>
                <label style={labelStyle}>Bairro</label>
                <input style={inputStyle} value={form.bairro} onChange={e => setForm({ ...form, bairro: e.target.value })} placeholder="Bairro" />
              </div>
              <div>
                <label style={labelStyle}>Cidade</label>
                <input style={inputStyle} value={form.cidade} onChange={e => setForm({ ...form, cidade: e.target.value })} placeholder="Londrina" />
              </div>
              <div>
                <label style={labelStyle}>Estado</label>
                <input style={inputStyle} value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })} placeholder="PR" maxLength={2} />
              </div>
            </div>

            <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>Plano</label>
                <select style={inputStyle} value={form.plano} onChange={e => setForm({ ...form, plano: e.target.value })}>
                  <option value="com_bloqueio">🔒 Com bloqueio remoto</option>
                  <option value="sem_bloqueio">🔓 Sem bloqueio remoto</option>
                </select>
              </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <button onClick={fecharModal} style={{ padding: '10px 20px', border: '1.5px solid #ddd', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '14px' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ padding: '10px 24px', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', cursor: salvando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : clienteSelecionado ? 'Atualizar' : 'Salvar Cliente'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Clientes;